import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ScSwitchComponent),
  multi: true
};

@Component({
    selector: 'sc-switch',
    templateUrl: './switch.component.html',
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR],
    styleUrls: ['./switch.component.scss'],
    standalone: false
})
export class ScSwitchComponent implements OnInit, ControlValueAccessor {

  innerValue: boolean = false;

  //Placeholders for the callbacks which are later provided
  //by the Control Value Accessor
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  //get accessor
  get value(): any {
    return this.innerValue;
  };

  //set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  //Set touched on blur
  onBlur() {
    this.onTouchedCallback();
  }

  //From ControlValueAccessor interface
  writeValue(value: any) {
    if (value !== this.value) {
      this.innerValue = value;
    }
  }

  //From ControlValueAccessor interface
  registerOnChange(fn: any) {
    this.onChangeCallback = fn;
  }

  //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
    this.onTouchedCallback = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  constructor() { }

  ngOnInit() {
    var S4 = function () { return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1); };
    var generateId = function (length) {
      var id = "";
      for (var i = 0; i < length; i++) id += S4();
      return id;
    }

    this.elementId = 'switch_' + generateId(4);
  }

  elementId: string;

  @Input() 
  isChecked: boolean;

  @Input() 
  label: string;

  @Input()
  isDisabled = false;
}
